module.exports = __webpack_public_path__ + "img/logo-en.7685849f.png";